// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteAccountGetAccountGetAccountResponseModel } from './siteAccountGetAccountGetAccountResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountSiteAccountGetAccountDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': SiteAccountGetAccountGetAccountResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountSiteAccountGetAccountDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "SiteAccountGetAccountGetAccountResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountSiteAccountGetAccountDefaultResponse.attributeTypeMap;
    }
}
